<template>
  <div class="permission-tooltip" v-if="show">
    <div class="tooltip-content">
      <img src="@/assets/images/info-circle.svg" alt="icon-info" class="icon" />
      <span>No dispones de los permisos necesarios para realizar esta acción</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PermissionTooltip',
  props: {
    show: {
      type: Boolean,
      default: false
    },
  }
}
</script>


<style lang="scss" scoped>
@import '@/design/views/permission-tooltip.scss';
</style>
